module.exports = __webpack_public_path__ + "static/media/quotation.794366f9.svg";